import { isEmpty } from 'lodash';

import { CallEntrypointSchema, CallListSchema, isNilOrDefault } from '@pwp-common';

const callEntrypointSchema = new CallEntrypointSchema();
const callListSchema = new CallListSchema();

export function joinCallEntrypointAndCallListNames(
  callEntrypointName: string | undefined,
  callListName: string | undefined,
): string {
  const names: string[] = [];

  if (
    !isEmpty(callEntrypointName) &&
    !isNilOrDefault(callEntrypointName, CallEntrypointSchema.displayName, callEntrypointSchema)
  ) {
    names.push(callEntrypointName as string);
  }

  if (!isEmpty(callListName) && !isNilOrDefault(callListName, CallListSchema.displayName, callListSchema)) {
    names.push(callListName as string);
  }

  return names.join('->');
}
